export function generatePixel(url) {
    const img = new Image();
    img.src = url;
    return img;
}
